/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import styled from 'styled-components';
import bindMethods from 'auto-bind';
import videojs from 'video.js';
import seekButtons from 'videojs-seek-buttons';

const PlayerContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

export default class VideoPlayer extends React.Component {
  constructor(props) {
    super(props);
    bindMethods(this);
  }

  componentDidMount() {
    this.player = videojs(this.videoNode, this.props, () => {
      // onPlayerReady:
    });

    videojs.log.level('off');

    this.player.seekButtons({
      forward: 15,
      back: 15,
    });

    const playToggleButton = this.player.controlBar.getChild('PlayToggle');

    this.player.controlBar.on('mousedown', (e) => {
      e.preventDefault();
      playToggleButton.focus();
    });
  }

  render() {
    return (
      <PlayerContainer data-vjs-player>
        <video
          // eslint-disable-next-line no-return-assign
          ref={(node) => (this.videoNode = node)}
          id="AssetDetails.MediaContent.VideoContent"
          className="video-js vjs-16-9 vjs-big-play-centered"
          onContextMenu={(e) => {
            e.preventDefault();
          }}
        />
      </PlayerContainer>
    );
  }
}
